import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ConnectionStatus } from '../../types';
import type { TimeMode } from '@types';
import type { SiteMeta } from '@src/types/SiteMeta';
import ConnectionIndicator from '../ConnectionStatus/index';
import { formatTimestampForDisplay } from '@utils/timezoneUtils';
import { headerSectionStyles } from './styles';

interface HeaderSectionProps {
  connectionStatus: ConnectionStatus;
  lastDataUpdate: Date | null;
  timeMode: TimeMode;
  siteMeta: SiteMeta;
}

const HeaderSection: React.FC<HeaderSectionProps> = React.memo(
  ({ connectionStatus, lastDataUpdate, timeMode, siteMeta }) => {
    const theme = useTheme();

    const formattedLastUpdate = useMemo(() => {
      if (!lastDataUpdate) {
        return null;
      }

      return formatTimestampForDisplay(
        lastDataUpdate.toISOString(),
        timeMode,
        siteMeta,
      );
    }, [lastDataUpdate, timeMode, siteMeta]);

    return (
      <Box sx={headerSectionStyles}>
        <ConnectionIndicator
          connectionStatus={connectionStatus}
          lastDataUpdate={lastDataUpdate}
        />

        {formattedLastUpdate && (
          <Typography
            variant='caption'
            sx={{
              color: theme.palette.text.secondary,
              fontStyle: 'italic',
            }}
          >
            Last update: {formattedLastUpdate}
          </Typography>
        )}
      </Box>
    );
  },
);

HeaderSection.displayName = 'HeaderSection';

export default HeaderSection;
